// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-content {
    margin-top: 0;
    background: none;
    border: none;
}

.box-content-tab-default {
    padding: 15px 30px;
    margin-bottom: 15px;
    font-size: 13px;
}
@media screen and (max-width: 992px) {
    .box-content-tab-default {
        margin-top: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Profile/Profile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".tab-content {\n    margin-top: 0;\n    background: none;\n    border: none;\n}\n\n.box-content-tab-default {\n    padding: 15px 30px;\n    margin-bottom: 15px;\n    font-size: 13px;\n}\n@media screen and (max-width: 992px) {\n    .box-content-tab-default {\n        margin-top: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
